import { useState, useCallback, useMemo, useEffect } from 'react';
import {
  DomainArea,
  getDomainSelectorConfig,
} from '../../config/domainSelectorAgents';
import { AgentConfig } from '../../types/agent.types';

const EMPTY_DOMAINS: readonly DomainArea[] = [];

export const useAgentDomainSelector = (activeAgent: AgentConfig | null) => {
  const domainConfig = useMemo(
    () => getDomainSelectorConfig(activeAgent?.name),
    [activeAgent?.name],
  );
  const defaultDomain = domainConfig?.defaultDomain ?? null;
  const [selectedDomain, setSelectedDomain] = useState<DomainArea | null>(
    defaultDomain,
  );

  useEffect(() => {
    setSelectedDomain(defaultDomain);
  }, [activeAgent?.id, defaultDomain]);

  const availableDomains = useMemo(
    () => domainConfig?.domains ?? EMPTY_DOMAINS,
    [domainConfig?.domains],
  );
  const disabledDomains = useMemo(
    () => domainConfig?.disabledDomains ?? EMPTY_DOMAINS,
    [domainConfig?.disabledDomains],
  );
  const domainSelectorEnabled = domainConfig != null;

  const setDomain = useCallback(
    (domain: DomainArea) => {
      if (disabledDomains.includes(domain)) return;
      setSelectedDomain(domain);
    },
    [disabledDomains],
  );

  const resetDomain = useCallback(() => {
    setSelectedDomain(defaultDomain);
  }, [defaultDomain]);

  return {
    selectedDomain,
    setSelectedDomain: setDomain,
    availableDomains,
    disabledDomains,
    domainSelectorEnabled,
    resetDomain,
  };
};
